import { FC } from 'react';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import type { PriceInfo } from 'src/components/AzarOnly/Subscription/types';
import LoadingIndicatorBase from 'src/components/LoadingIndicator';
import ResizingText from 'src/components/ResizingText';
const LoadingIndicator = styled(LoadingIndicatorBase)`
  color: ${({
  theme
}) => theme.color.contentBright};
`;
const ButtonContainer = styled.button<{
  $isHighTier?: boolean;
  $disabled?: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5px;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  height: 52px;
  padding: 0 16px;
  border: none;
  border-radius: 360px;
  transition: background-color 0.2s ease;
  overflow: hidden;

  background-color: ${({
  $isHighTier,
  $disabled,
  theme
}) => $disabled ? theme.color.surface4 : $isHighTier ? theme.color.primary1 : theme.color.surface12};

  cursor: ${({
  $disabled
}) => $disabled ? 'default' : 'pointer'};

  &:hover {
    opacity: ${({
  $disabled
}) => $disabled ? 1 : 0.9};
  }
`;
const MainText = styled(ResizingText)<{
  $disabled?: boolean;
}>`
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  text-align: center;
  color: ${({
  $disabled,
  theme
}) => $disabled ? theme.color.content6 : theme.color.contentInverse};
`;
const SubText = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  text-align: center;
  color: ${({
  theme
}) => theme.color.contentInverse};
`;
const StrikePrice = styled.span`
  text-decoration: line-through;
`;
interface Props {
  isHighTier?: boolean;
  priceInfo?: PriceInfo;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  children?: string;
}
const SubscriptionPurchaseButton: FC<Props> = ({
  isHighTier,
  priceInfo,
  onClick,
  className,
  children,
  disabled,
  loading
}) => {
  const {
    isRtl
  } = useTheme();
  const hasIntroductoryOffer = !!priceInfo?.formattedIntroductoryPrice; // 첫구매 할인혜택

  return <ButtonContainer $isHighTier={isHighTier} $disabled={disabled} onClick={disabled ? undefined : onClick} className={className} disabled={disabled} data-sentry-element="ButtonContainer" data-sentry-component="SubscriptionPurchaseButton" data-sentry-source-file="SubscriptionPurchaseButton.tsx">
      {loading ? <LoadingIndicator size={24} /> : <>
          <MainText minFontSize={12} maxLines={1} $disabled={disabled}>
            {children}
          </MainText>
          {!disabled && priceInfo && <SubText>
              {hasIntroductoryOffer ? <>
                  <StrikePrice>{priceInfo.formattedPrice}</StrikePrice>
                  <span>{isRtl ? ' ← ' : ' → '}</span>
                  <span>{priceInfo.formattedIntroductoryPriceWithPeriod}</span>
                </> : <span>{priceInfo.formattedPriceWithPeriod}</span>}
            </SubText>}
        </>}
    </ButtonContainer>;
};
export default SubscriptionPurchaseButton;